<template>
  <nav :class="{'nav-bar': $route.path === '/', 'nav-bar-nohome': $route.path !== '/'}" :key="forceRender">
    <div class="nav-container">
      <!-- Logo -->
      <div class="nav-left">
        <div class="nav-logo">
          <router-link :to="'/'" class="logo-link">
            <img :src="$route.path === '/' ? '/platforms/logo.png' : '/platforms/logo-jdh-web.png'" :alt="logo.alt_text" class="logo-image" style="vertical-align: middle;">
            <!-- <span :class="{'logo-text': $route.path === '/', 'logo-text-nohome': $route.path !== '/'}" style="vertical-align: middle;">简单画</span> -->
          </router-link>
        </div>
      </div>

      <!-- 主导航菜单 -->
      <div class="nav-menu">
        <router-link to="/" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">首页</router-link>
        
        <!-- 素材中心 -->
        <div class="nav-dropdown">
          <span :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">素材中心</span>
          <div class="search-icon-wrapper" @click.stop="showMaterialSearchDialog = true">
            <el-icon class="search-icon"><Search /></el-icon>
          </div>
          <div class="dropdown-content">
            <router-link to="/materials/character">人物素材</router-link>
            <router-link to="/materials/scene">场景素材</router-link>
            <router-link to="/materials/expression">表情素材</router-link>
            <router-link to="/materials/creature">兽类素材</router-link>
            <router-link to="/materials/prop">道具素材</router-link>
            <router-link to="/materials/effect">特效素材</router-link>
            <router-link to="/materials/ai">AI素材</router-link>
            <router-link to="/materials/all">全部素材</router-link>
          </div>
        </div>

        <router-link to="/custom" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">定制中心</router-link>
        <router-link to="/dubbing" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">配音中心</router-link>

        <!-- 配音中心 -->
        <!-- <div class="nav-dropdown">
          <span :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">配音中心</span>
          <div class="dropdown-content">
            <a href="https://www.moyin.com/" target="_blank">魔音工坊</a>
            <a href="https://www.douge.com/companyProfile" target="_blank">逗哥配音</a>
            <a href="https://www.ttson.cn/?source=BiC2Ho" target="_blank">海豚配音</a>
            <a href="https://www.modelscope.cn/studios/iic/CosyVoice2-0.5B" target="_blank">CosyVoice</a>
            <a href="https://ttsmaker.cn/" target="_blank">免费配音</a>
          </div>
        </div> -->

        <router-link to="/tools" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">实用工具</router-link>
        <router-link to="/video_release" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">视频发布</router-link>

        <!-- 视频发布 -->
        <!-- <div class="nav-dropdown">
          <span :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">视频发布</span>
          <div class="dropdown-content">
            <a href="https://creator.douyin.com" target="_blank">抖音</a>
            <a href="https://cp.kuaishou.com" target="_blank">快手</a>
            <a href="https://member.bilibili.com/platform/home" target="_blank">B站</a>
            <a href="https://channels.weixin.qq.com" target="_blank">微信视频号</a>
            <a href="https://baijiahao.baidu.com" target="_blank">百家号</a>
            <a href="https://creator.xiaohongshu.com" target="_blank">小红书</a>
            <a href="https://qqzz.qq.com/public/login" target="_blank">QQ小视频</a>
            <a href="https://mp.v.qq.com/publishVideo/video" target="_blank">腾讯视频</a>
            <a href="https://c.alipay.com/page/portal/home" target="_blank">支付宝</a>
          </div>
        </div> -->

        <router-link to="/monetize" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">变现渠道</router-link>
        <router-link to="/jdh-tool" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">简单画工具</router-link>
        <router-link to="/tutorial" :class="{'nav-link': $route.path === '/', 'nav-link-nohome': $route.path !== '/'}">教程中心</router-link>
      </div>

      <!-- 右侧功能区 -->
      <div class="nav-right">

        
        <!-- 用户头像区域 - 已登录状态 -->
        <div v-if="isAuthenticated && isVip" class="username-display" style="margin-right: 10px; cursor: pointer;" @click="copyUserId">
            ID:   {{ getUserId() }}
        </div>

        <!-- 直接使用NotificationCenter组件 -->
        <NotificationCenter />

        <div 
          class="user-wrapper" 
          v-if="isAuthenticated"
          @mouseenter="showUserMenu = true"
          @mouseleave="showUserMenu = false"
        >
          <div class="username-display">
            {{ getUserDisplayName() }}
            <el-icon class="el-icon--right"><ArrowDown /></el-icon>
          </div>
          <!-- 用户菜单 -->
          <div class="user-menu" v-show="showUserMenu">
            <a @click="showToolsGuideDialog = true">工具使用指导</a>
            <a @click="showChangePasswordDialog = true">修改密码</a>
            <a @click="showActivateVipDialog = true">激活会员</a>
            <!-- <a href="https://docs.qq.com/form/page/DZXBaRGtNSE1SRnN6" target="_blank">账号报备</a> -->
            <a @click="handleLogout">退出登录</a>
          </div>
        </div>
        
        <!-- 未登录状态 -->
        <div v-else class="login-wrapper">
          <div class="login-register-btn">
            <a href="javascript:void(0)" @click="showLoginDialog" class="login-part">登录</a>
            <span>/</span>
            <a href="javascript:void(0)" @click="showRegisterDialog" class="register-part">注册</a>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- 添加修改密码弹窗 -->
  <ChangePasswordDialog
    v-model:visible="showChangePasswordDialog"
    @success="handlePasswordChangeSuccess"
  />

  <!-- 工具使用指导 -->
  <ToolsGuideDialog
    v-model:visible="showToolsGuideDialog"
  />

  <!-- 激活会员天窗 -->
  <ActivateVipDialog
    v-model:visible="showActivateVipDialog"
    @success="handleActivateVipSuccess"
  />

  <!-- 素材中心搜索对话框 -->
  <el-dialog
    v-model="showMaterialSearchDialog"
    title="素材搜索"
    width="400px"
    :before-close="handleDialogClose"
  >
    <div class="search-dialog-content">
      <el-input
        v-model="materialSearchKeyword"
        placeholder="请输入素材关键词"
        prefix-icon="Search"
        class="search-input"
        @keyup.enter="handleMaterialSearch"
      />
      <el-button
        type="primary"
        class="search-button"
        @click="handleMaterialSearch"
      >
        搜索
      </el-button>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch, nextTick, inject, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import NotificationCenter from '@/components/notification/NotificationCenter.vue'
import ChangePasswordDialog from '@/components/user/ChangePasswordDialog.vue'
import ToolsGuideDialog from '@/components/user/ToolsGuideDialog.vue'
import ActivateVipDialog from '@/components/user/ActivateVipDialog.vue'
import { Bell, ArrowDown, Search } from '@element-plus/icons-vue'
import { ElMessage, ElDialog, ElInput, ElButton } from 'element-plus'
// 引入自定义认证状态管理
import authState from '@/utils/authState'
import requestV2 from '@/utils/requestV2';
// 引入事件总线
import eventBus, { EventTypes } from '@/utils/eventBus';

// 引入登录弹窗管理
import authDialog from '@/utils/authDialog'
import registerDialog from '@/utils/registerDialog'

const backendUrl = ref(import.meta.env.VITE_JAVA_API_URL)

// 定义接收的 props
const props = defineProps({
  isLoggedIn: {
    type: Boolean,
    default: false
  }
});

const router = useRouter()
const userStore = useUserStore()
const showUserMenu = ref(false)
const forceRender = ref(Date.now()) // 用于强制组件重新渲染的key值
let prevAuthState = false // 记录上一次的认证状态

// 使用计算属性来监听登录状态
const isAuthenticated = computed(() => {
  // 使用authState的isLoggedIn计算属性
  const isLoggedIn = authState.isLoggedIn.value;
  console.log('NavBar - 使用authState检查登录状态:', isLoggedIn);
  
  // 如果当前渲染周期检测到登录状态变化，设置forceRender为当前时间戳
  if (prevAuthState !== isLoggedIn) {
    console.log(`NavBar - 检测到登录状态变化: ${prevAuthState} -> ${isLoggedIn}, 将在下一周期强制更新UI`);
    prevAuthState = isLoggedIn;
    
    // 使用setTimeout确保在当前渲染周期后更新
    setTimeout(() => {
      forceRender.value = Date.now();
      console.log('NavBar - 强制更新UI触发, key:', forceRender.value);
    }, 0);
  }
  
  return isLoggedIn;
});

// 使用计算属性来监听登录状态
const isVip = computed(() => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user.vip_level > 0;
});


// 监视用户状态变化，主动刷新状态
watch(() => userStore.isLoggedIn, (newValue, oldValue) => {
  console.log('NavBar - 用户登录状态变化:', oldValue, '->', newValue);
  // 强制组件重新计算状态
  nextTick(() => {
    console.log('NavBar - 用户状态刷新后:', { 
      storeLoggedIn: userStore.isLoggedIn,
      localStorage: !!localStorage.getItem('token')
    });
  });
}, { immediate: true });

// 监视 props 变化
watch(() => props.isLoggedIn, (newValue) => {
  console.log('NavBar - props.isLoggedIn 变化:', newValue);
  // 强制检查登录状态
  nextTick(() => {
    console.log('NavBar - props变化后检查:', { 
      storeLoggedIn: userStore.isLoggedIn,
      propsLoggedIn: props.isLoggedIn
    });
  });
}, { immediate: true });

// Logo数据
const copyUserId = () => {
  const userId = getUserId();
  navigator.clipboard.writeText(userId).then(() => {
    ElMessage.success('用户ID已复制到剪贴板');
  }).catch(err => {
    ElMessage.error('复制失败，请手动复制');
    console.error('复制失败:', err);
  });
};

const logo = ref({
  image_url: '',
  link_url: '/',
  alt_text: '简单画素材网'
})

// 获取Logo数据
const fetchLogo = async () => {
  try {
    const response = await fetch(`${backendUrl.value}/system/siteLogo/getLogo`)
    if (response.ok) {
      const data = await response.json()
      if (data) {
        logo.value = data.data
      }
    }
  } catch (error) {
    console.error('获取Logo失败:', error)
  }
}

// 使用ref记录最后更新的时间戳，用于强制更新
const lastUpdateTimestamp = ref(Date.now());

// 添加一个轮询函数，定期检查localStorage中的登录状态
let authCheckInterval: ReturnType<typeof setInterval> | null = null;

// 在组件挂载时设置轮询检查
onMounted(() => {
  fetchLogo();
  
  // 添加全局事件监听
  window.addEventListener('auth:login', handleAuthChange);
  window.addEventListener('auth:logout', handleAuthChange);
  
  console.log('NavBar组件挂载 - 登录状态检查:', {
    authState: authState.isLoggedIn.value,
    username: authState.user.value?.username || null
  });
});

// 组件卸载时移除监听器
onUnmounted(() => {
  // 移除全局事件监听
  window.removeEventListener('auth:login', handleAuthChange);
  window.removeEventListener('auth:logout', handleAuthChange);
  
  // 清除轮询定时器
  if (authCheckInterval) {
    clearInterval(authCheckInterval);
  }
});

// 定义事件处理器类型
interface AuthEvent extends Event {
  type: string;
  detail?: any;
}

// 处理认证状态变化
const handleAuthChange = (event: AuthEvent) => {
  console.log('NavBar - 收到认证状态变化事件:', event.type);
  // 强制重新渲染
  forceRender.value = Date.now();
};

// 处理退出登录
const handleLogout = async () => {
  try {
    console.log('开始登出操作')
    
    // 使用authState登出
    authState.logout();
    
    // 隐藏用户菜单
    showUserMenu.value = false
    
    // 强制刷新UI状态
    await nextTick()
    forceRender.value = Date.now()
    console.log('NavBar - 登出后强制更新UI，key:', forceRender.value)
    
    // 显示成功消息
    ElMessage.success('退出登录成功')
    
    // 留在当前页面，或导航到首页
    if (router.currentRoute.value.meta.requiresAuth) {
      router.push('/')
    }
  } catch (error) {
    console.error('退出登录失败:', error)
    ElMessage.error('退出登录失败，请重试')
    
    // 即使出错也强制清除状态
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    
    // 强制刷新UI
    await nextTick()
    forceRender.value = Date.now()
    console.log('NavBar - 登出错误后强制更新UI，key:', forceRender.value)
    
    // 导航到首页
    router.push('/')
  }
}

// 格式化用户名，中间使用*代替
const formatUsername = (username?: string, showFull: boolean = false) => {
  if (!username) return '用户';
  
  // 如果选择显示完整用户名，直接返回
  if (showFull) return username;
  
  // 判断是否是11位数字（手机号）
  if (/^\d{11}$/.test(username)) {
    // 显示前3位和后4位，中间4位用*代替
    return username.substring(0, 3) + '****' + username.substring(7);
  }
  
  // 其他情况，保留首尾字符，中间用*代替
  const length = username.length;
  if (length <= 2) return username;
  
  const firstChar = username.charAt(0);
  const lastChar = username.charAt(length - 1);
  // 根据长度决定中间*的数量，最少1个
  const maskLength = Math.min(length - 2, 4);
  const mask = '*'.repeat(maskLength);
  
  return firstChar + mask + lastChar;
}

// 修改密码相关
const showChangePasswordDialog = ref(false);
const showToolsGuideDialog = ref(false);
// 激活会员
const showActivateVipDialog = ref(false);

// 素材中心搜索对话框
const showMaterialSearchDialog = ref(false);
const materialSearchKeyword = ref('');

// 处理素材搜索
const handleMaterialSearch = () => {
  if (materialSearchKeyword.value.trim()) {
    // 触发搜索关键词变化事件，通知All页面
    eventBus.emit(EventTypes.MATERIAL_SEARCH_KEYWORD_CHANGE, materialSearchKeyword.value.trim());
    
    // 跳转到全部素材页面并带上搜索关键词和时间戳，确保每次都重新加载数据
    router.push({
      path: '/materials/all',
      query: {
        keyword: materialSearchKeyword.value.trim(),
        _t: Date.now() // 添加时间戳参数，强制重新加载页面数据
      }
    });
    
    materialSearchKeyword.value = '';
    // 关闭搜索对话框
    showMaterialSearchDialog.value = false;
  } else {
    ElMessage.warning('请输入搜索关键词');
  }
};

// 处理对话框关闭
const handleDialogClose = (done: () => void) => {
  // 重置搜索关键词
  materialSearchKeyword.value = '';
  // 确认关闭对话框
  done();
};

// 处理密码修改成功
const handlePasswordChangeSuccess = () => {
  showChangePasswordDialog.value = false;
  showUserMenu.value = false;
  ElMessage.success('密码修改成功');
};

// 处理密码修改成功
const handleActivateVipSuccess = async () => {
  //激活成功：重新获取用户信息并设置到缓存里面然后刷新页面
  const user = JSON.parse(localStorage.getItem('user'));
  const response = await requestV2.get(`/system/users/${user.id}`);
  localStorage.setItem('user', JSON.stringify(response.data.data));
  showActivateVipDialog.value = false;
  showUserMenu.value = false;
  ElMessage.success('激活会员成功');
  setTimeout(() => {
    window.location.reload();
  }, 1000);
};

// 强制导航到登录页面
const forceNavigateToLogin = (event: Event) => {
  event.preventDefault();
  // 显示登录弹窗
  showLoginDialog();
};

// 显示登录弹窗
const showLoginDialog = () => {
  authDialog.show();
};

// 显示注册登录弹窗
const showRegisterDialog = () => {
  registerDialog.show();
};

// 获取用户显示名称
const getUserDisplayName = () => {
  // 从authState获取用户名
  if (authState.user.value?.username) {
    console.log('NavBar - 从authState获取用户名:', authState.user.value.username);
    return formatUsername(authState.user.value.username, false); // 使用掩码处理，不显示完整用户名
  }
  
  // 默认显示
  return '用户';
};


// 获取用户显示名称
const getUserId = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  // 从authState获取用户名
  if (user?.tool_login_id) {
    console.log('NavBar - 从authState获取用户名:', user.tool_login_id);
    return user.tool_login_id; // 使用掩码处理，不显示完整用户名
  }
  
  // 默认显示
  return '用户';
};
</script>

<style scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  /* background: white; */
  box-shadow: none;
  z-index: 1000;
  /* background-color: rgba(255, 255, 255, 0.9); */
  backdrop-filter: blur(10px);
}

.nav-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0;
  box-sizing: border-box;
}

.nav-left {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin-left: 0;
  position: absolute;
  left: 0;
}

.nav-logo {
  margin-right: 20px;
  margin-left: 200px;
  flex-shrink: 0;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-image {
  height: 40px;
}

.logo-text {
  font-size: 20px;
  font-weight: 500;
  color: #f7f7f7;
}

.nav-menu {
  flex: 1;
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  overflow: visible;
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 60px; /* 添加左右padding，为两侧的绝对定位元素留出空间 */
}

.nav-link {
  color: #f6f3f3 !important;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-link:hover {
  color: #333 !important;
  background: #f5f7fa;
}



.nav-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  padding-right: 0;
  margin-right: 40px;
  position: absolute;
  right: 10px;
}

.login-wrapper {
  display: flex;
  align-items: center;
}

.login-register-btn {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #CD98FF 0%, #A9B2FF 100%);
  padding: 6px 20px;
  border-radius: 10px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(205, 152, 255, 0.3);
}

.login-register-btn:hover {
  box-shadow: 0 4px 16px rgba(205, 152, 255, 0.5);
  transform: translateY(-1px);
}

.login-register-btn a {
  color: white;
  text-decoration: none;
  transition: all 0.3s;
}

.login-register-btn span {
  margin: 0 4px;
  color: white;
}

.login-register-btn .login-part:hover,
.login-register-btn .register-part:hover {
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
}

.login-btn {
  padding: 6px 20px;
  background-color: #409EFF;
  color: white;
  border-radius: 16px;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  margin-right: 5px;
}

.login-btn:hover {
  background-color: #66b1ff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.nav-dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0;
}

.search-icon-wrapper {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 4px;
  color: #999;
  transition: color 0.3s;
}

.search-icon-wrapper:hover {
  color: var(--primary-blue);
}

.search-dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0;
}

.search-input {
  width: 100%;
}

.search-button {
  width: 100%;
}

.nav-dropdown .nav-link {
  cursor: pointer;
  padding: 8px 12px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  border-radius: 4px;
  transition: all 0.3s;
}

.nav-dropdown .nav-link:hover {
  color: var(--primary-blue);
  background: #f5f7fa;
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  min-width: 160px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 8px 0;
  z-index: 1001;
  margin-top: 1px;
}

.nav-dropdown:hover {
  background: #f5f7fa;
}

.nav-dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content a {
  display: block;
  padding: 8px 16px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
  text-align: center;
  white-space: nowrap;
}

.dropdown-content a:hover {
  background: #f5f7fa;
  color: #1890ff;
}

.dropdown-content::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
}

.notification-wrapper {
  position: relative;
  margin-right: 20px;
}

.notification-icon {
  position: relative;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  color: #666;
}

.notification-icon:hover {
  color: #1890ff;
}

.unread-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #ff4d4f;
  color: white;
  border-radius: 10px;
  padding: 0 6px;
  font-size: 12px;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
}

.notification-preview {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  min-width: 200px;
  max-width: 300px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 8px 0;
  z-index: 1000;
}

.notification-item {
  padding: 8px 16px;
  cursor: pointer;
  transition: background 0.3s;
}

.notification-item:hover {
  background: #f5f7fa;
}

.no-notification {
  padding: 16px;
  text-align: center;
  color: #999;
}

.user-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  object-fit: cover;
  border: 2px solid #eee;
}

.username-display {
  padding: 6px 12px;
  background-color: #f0f5ff;
  border-radius: 16px;
  color: #409EFF;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #d9ecff;
  transition: all 0.3s;
}

.username-display:hover {
  background-color: #ecf5ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  min-width: 120px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 8px 0;
  z-index: 1001;
  margin-top: 8px;
}

.user-menu::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
}

.user-menu a {
  display: block;
  padding: 8px 16px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.user-menu a:hover {
  background: #f5f7fa;
  color: #1890ff;
}


.nav-bar-nohome {
  
  /* position: fixed; */
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: white;
  box-shadow: none;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
}

.nav-link-nohome {
  color: #333 !important;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-link-nohome:hover {
  color: #333 !important;
  background: #f5f7fa;
}
</style>